import SiteGlobal from './site-global.js';

// Popups
class Popups {
	static getAllowedTypes() {
		return [ 'text', 'inline', 'image', 'video', 'ajax' ];
	}

	// Init and Bind Events
	static init() {
		// Show
		SiteGlobal.bindEvent( 'click', '[data-popup]', function( event ) {
			event.preventDefault();

			// Should other popups be closed?
			if ( this.getAttribute( 'data-close-others' ) === 'yes' ) {
				Popups.hide();
			}

			// Display
			Popups.show( {
				isClosable: this.getAttribute( 'data-is-closable' ) === 'no' ? false : true,
				type: this.getAttribute( 'data-popup' ),
				src: this.getAttribute( 'data-src' ),
				size: this.getAttribute( 'data-size' ),
				parentClass: this.getAttribute( 'data-parent-class' ),
			} );
		} );

		// Hide
		SiteGlobal.bindEvent( 'click', '.js-site-popup-close', function( event ) {
			if ( this.getAttribute( 'disabled' ) === 'disabled' ) {
				return false;
			}
			event.preventDefault();

			Popups.hide();
		} );
	}

	/* Show
        settings: {
            type: possible values:
                - text: used in javascript for text popups. Set settings.src = 'text here';
                - inline: uses  hidden. element as source for popup. Set settings.src = '#id-of-element';
                - image: Set settings.src = 'absolute image path here';
                - video: Set settings.src = 'absolute video path here';
                - ajax: Set settings.src = 'absolute url to send request';
            src: what to render? Differs depending on type,
            size: small|medium|big
            isClosable: true / false
            parentClass: additional class to be added to popup parent css attribute
        }
    */
	static show( settings ) {
		// Is requested popup type allowed?
		if ( Popups.getAllowedTypes().indexOf( settings.type ) === -1 ) {
			console.warn( 'Error: Popup type not allowed!' ); // eslint-disable-line no-console
			return;
		}

		// Save last active popup and last focused document element
		const popupId = 'popup-' + SiteGlobal.toHex( settings.src );
		SiteGlobal.vars.popupsLastFocus = document.activeElement;
		SiteGlobal.vars.popupsStack.push( popupId );

		// If already generated just show
		const popup = document.getElementById( popupId );
		if ( popup ) {
			popup.style.display = 'block';
			popup.setAttribute( 'aria-hidden', 'false' );
			popup.querySelector( '.c-popup__content' ).focus();
			return true;
		}

		// Get the layout
		settings.isClosable = typeof settings.isClosable !== 'undefined' ? settings.isClosable : true;
		const layout = Popups.getLayout( {
			size: settings.size || 'medium',
			type: settings.type || 'inline',
			isClosable: settings.isClosable,
			parentClass: settings.parentClass || '',
		} );

		// Call requested popup type method
		const method = settings.type + 'Content';
		Popups[ method ]( settings, layout );
	}

	// Hide
	static hide() {
		// Hide and return the focus
		const popup = document.getElementById( Popups.stackPop() );
		if ( ! popup || popup.getAttribute( 'data-is-closable' ) === 'no' ) {
			return false;
		}
		popup.setAttribute( 'aria-hidden', 'true' );
		popup.style.display = 'none';
		SiteGlobal.vars.popupsLastFocus.focus();

		// Remove scroll lock
		document.body.classList.remove( 'u-scroll-lock' );

		// Remove from "stack"
		SiteGlobal.vars.popupsStack.pop();
	}

	// Render the HTML
	static render( settings, popup ) {
		// Create the popup element
		const lastInStack = Popups.stackPop();

		popup.className = `c-popup c-popup_type_${settings.type} ${settings.parentClass}`;
		popup.id = lastInStack;
		popup.style.display = 'block';
		popup.setAttribute( 'aria-hidden', 'false' );

		// Focus the content
		const popuContent = document.getElementById( lastInStack ).querySelector( '.c-popup__content' );
		popuContent.setAttribute( 'tabindex', '-1' );
		popuContent.focus();

		// Lock scroll
		document.body.classList.add( 'u-scroll-lock' );
	}

	static stackPop() {
		return SiteGlobal.vars.popupsStack[ SiteGlobal.vars.popupsStack.length - 1 ];
	}

	// Layout
	static getLayout( layoutParams ) {
		let header = '';
		if ( layoutParams.isClosable === true ) {
			header = `<div class="c-popup__header">
					<button type="button" class="js-site-popup-close c-popup__close">
						<svg xmlns="http://www.w3.org/2000/svg" width="18.385" height="18.385" viewBox="0 0 18.385 18.385"><path d="m2.828 0 15.556 15.556-2.828 2.829L0 2.828z"/><path d="M18.384 2.828 2.828 18.384l-2.829-2.828L15.556 0z"/></svg>
						Затвори
					</button>
				</div>`;
		}

		const html = `<div class="c-popup__overlay js-site-popup-close"></div>
			<div class="c-popup__body c-popup__body_size_${layoutParams.size}">
				${header}
				<div class="c-popup__content"></div>
			</div>`;

		const popup = document.createElement( 'div' );
		popup.innerHTML = html;
		popup.style.display = 'block';
		document.body.appendChild( popup );

		return popup;
	}

	// Text Content
	static textContent( settings, popup ) {
		const html = settings.src;
		popup.querySelector( '.c-popup__content' ).innerHTML = html;
		Popups.render(
			settings,
			popup,
		);
	}

	// Inline Content
	static inlineContent( settings, popup ) {
		const sourceElement = document.getElementById( settings.src.replace( '#', '' ) );
		if ( ! sourceElement ) {
			console.warn( 'Error: source element not found!' ); // eslint-disable-line no-console
			return;
		}

		popup.querySelector( '.c-popup__content' ).appendChild( sourceElement );

		Popups.render(
			settings,
			popup,
		);
	}

	// Image Content
	static imageContent( settings, popup ) {
		const html = '<img src="' + settings.src + '" alt=""/>';
		popup.querySelector( '.c-popup__content' ).innerHTML = html;
		Popups.render(
			settings,
			popup,
		);
	}

	// Video Content
	// eslint-disable-next-line
	static videoContent( settings, popup ) {
		// @TODO if needed
	}

	// Ajax Content
	// eslint-disable-next-line
	static ajaxContent( settings, popup ) {
		// @TODO if needed
	}
}

export default Popups;
